import {FlowBlock, FlowPoint, FlowWire} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {FlowUtil} from '@mintdata-wsp/common/util/FlowUtil';
import {FlowCanvasController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowCanvasController';
import {WireRoute} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowWiresController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {FlowBlockContextMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/canvas/contextMenus/FlowBlockContextMenu';
import {FlowWireContextMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/canvas/contextMenus/FlowWireContextMenu';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FlowWiresView.less');
const cx = classnames.bind(styles);

@observer
export class FlowWiresView extends React.Component<any, any>
{

    private static _FLOW_WIRES_SINGLETON_SVG_ELEMENT = `flowWiresSvgSingleton`;
    private static _MINT_BLUE2_COLOR = `rgba(66,133,244,1.0)`; //`#4285F4`;
    private static _FLOW_BLOCK_SELECTED_BORDER_COLOR = `rgba(74, 144, 226, 1.0);`;
    private static _COOL_HUE_BLUE_COLOR = `rgba(63, 144, 185, 0.75)`;

    @bind
    private _onWiresSvgRef(ref:SVGElement):void
    {
        controllers.ui.flowCanvas.setWiresSvgElement(ref);
    }

    @bind
    private _onPreventBrowserContextMenu(reactEvent:React.MouseEvent<any>):any
    {
        const e = reactEvent.nativeEvent;

        if( e.which === 3 )
        {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            return false;
        }
    }

    @bind
    private _onWiresContainerMouseDown(e:React.MouseEvent<any>)
    {
        const target = e.nativeEvent.target as any;

        if( target && target.id === FlowWiresView._FLOW_WIRES_SINGLETON_SVG_ELEMENT )
        {
            const controller = controllers.ui.flowCanvas;

            controller.closeWireContextMenu();
            controllers.ui.flowSelection.clearSelectedWire();
            controllers.ui.flowSelection.clearSelectedBlocks();
        }
    }

    @bind
    private _onWireMouseDown(wire:FlowWire):any
    {
        return (reactEvent:React.MouseEvent<any>) =>
        {
            const controller = controllers.ui.flowSelection;
            controller.setSelectedWire(wire);

            const e = reactEvent.nativeEvent;
            if( e.which === 3 )
                controllers.ui.flowCanvas.openWireContextMenu(e, wire);
        };
    }

    @bind
    private _onWireMouseUp():void
    {
        controllers.ui.flowCanvas.focusCanvas();
    }

    private _renderWire(wire:FlowWire, strokeColor:string):any
    {
        return this._renderWireCurvedJoints(wire, strokeColor);
    }

    private _renderWireCurvedJoints(wire:FlowWire, strokeColor:string):any
    {
        if( FlowCanvasController.HIDE_DEBUG_BLOCKS_AND_WIRES )
        {
            if( (wire.target.block && wire.target.block.isDebugBlock) ||
                (wire.source.block && wire.source.block.isDebugBlock) )
                    return null;
        }

        const controller = controllers.ui.flowSelection;
        const wireSegments = controllers.ui.flowWires.getRouting(wire);

        if( !wireSegments || wireSegments.length === 0 )
            return null;

        let zIndex = undefined;
        let strokeWidth = FlowUtil.WIRE_THICKNESS;

        const selectedWire = controller.getSelectedWire();
        if( selectedWire && selectedWire.id == wire.id )
        {
            strokeColor = FlowWiresView._MINT_BLUE2_COLOR;
            zIndex = 10000;
            strokeWidth = 4;
        }
        else
        {
            strokeColor = FlowWiresView._COOL_HUE_BLUE_COLOR;
            zIndex = -100;
        }

        const style =
        {
            fill: 'none',
            stroke: strokeColor,
            strokeWidth: strokeWidth,
            strokeLineJoin: 'round',
            zIndex:zIndex
        };

        let firstSegment = wireSegments[0];
        let sb = `M ${firstSegment.from.x} ${firstSegment.from.y} `;
        sb += firstSegment.endRadius
            ? `L ${firstSegment.to_2.x} ${firstSegment.to_2.y} `
            : `L ${firstSegment.to.x} ${firstSegment.to.y} `;

        for( let i = 1; i < wireSegments.length; i++ )
        {
            const seg = wireSegments[i];
            sb += seg.startRadius
                ? `Q ${seg.from.x} ${seg.from.y} ${seg.from_2.x} ${seg.from_2.y} `
                : '';
            sb += seg.endRadius
                ? `L ${seg.to_2.x} ${seg.to_2.y} `
                : `L ${seg.to.x} ${seg.to.y} `;
        }

        return  <path d={sb}
                      key={wire.id}
                      style={style}
                      onMouseDown={this._onWireMouseDown(wire)}
                      onMouseUp={this._onWireMouseUp}
                />;
    }

    private _renderWire_90DegreeJoints(wire:FlowWire, strokeColor:string):any
    {
        if( FlowCanvasController.HIDE_DEBUG_BLOCKS_AND_WIRES )
        {
            if( (wire.target.block && wire.target.block.isDebugBlock) ||
                (wire.source.block && wire.source.block.isDebugBlock) )
                return null;
        }

        const controller = controllers.ui.flowSelection;
        const wireSegments = controllers.ui.flowWires.getRouting(wire);

        if( !wireSegments || wireSegments.length === 0 )
            return null;

        let zIndex = undefined;
        let strokeWidth = FlowUtil.WIRE_THICKNESS;

        const selectedWire = controller.getSelectedWire();
        if( selectedWire && selectedWire.id == wire.id )
        {
            strokeColor = FlowWiresView._MINT_BLUE2_COLOR;
            zIndex = 10000;
            strokeWidth = 4;
        }
        else
        {
            strokeColor = FlowWiresView._COOL_HUE_BLUE_COLOR;
            zIndex = -100;
        }

        const style =
            {
                fill: 'none',
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLineJoin: 'round',
                zIndex:zIndex
            };

        let firstSegment = wireSegments[0];
        let sb = `M ${firstSegment.from.x} ${firstSegment.from.y} `;
        sb += `L ${firstSegment.to.x} ${firstSegment.to.y} `;

        for( let i = 1; i < wireSegments.length; i++ )
        {
            const to:FlowPoint = wireSegments[i].to;
            sb += `L ${to.x} ${to.y} `;
        }

        return  <path d={sb}
                      key={wire.id}
                      style={style}
                      onMouseDown={this._onWireMouseDown(wire)}
        />;
    }

    private _renderAsLines(wire:FlowWire, style:any)
    {
        const wireSegments = controllers.ui.flowWires.getRouting(wire);

        return wireSegments.map((wireSegment:WireRoute, idx)=>
                         {
                             const from = wireSegment.from;
                             const to = wireSegment.to;

                             return <line key={IdUtil.newGUID()}
                                          x1={from.x} y1={from.y}
                                          x2={to.x} y2={to.y}
                                          style={style}
                                          onMouseDown={this._onWireMouseDown(wire)}
                                    />;
                         });
    }

    private _renderActiveWire():JSX.Element
    {
        const activeWire = controllers.ui.flowCanvas.getActiveWire();
        if( !activeWire )
            return;

        return <g>{this._renderWire(activeWire, FlowWiresView._MINT_BLUE2_COLOR)}</g>;
    }

    private _wireIdToColor:any = {};

    @bind
    private _getOrCreateWireColor(wire:FlowWire):string
    {
        if( this._wireIdToColor[wire.id] )
            return this._wireIdToColor[wire.id];
        else
        {
            const r = Math.floor(Math.random()*255);
            const g = Math.floor(Math.random()*255);
            const b =  Math.floor(Math.random()*255);

            const newColor = `rgba(${r},${g},${b},0.75)`;
            this._wireIdToColor[wire.id] = newColor;
            return newColor;
        }
    }

    private _renderPermanentWires():JSX.Element
    {
        const controller = controllers.ui.flowCanvas;
        const selectionController = controllers.ui.flowSelection;
        const blocks = controller.getCurrentFlowBlocks();
        if( !blocks )
            return null;

        const selectedWire = selectionController.getSelectedWire();

        return <g tabIndex={-1}>
                {
                    blocks.map((block:FlowBlock)=>
                    {
                        return block.outWires.map((wire:FlowWire)=>
                        {
                            const wireColor = this._getOrCreateWireColor(wire);

                            if( !selectionController.isSelectedWire(wire) )
                                return this._renderWire(wire, wireColor);
                        });
                    })
                }
                {
                    selectedWire? this._renderWire(selectedWire, FlowWiresView._MINT_BLUE2_COLOR)
                                : null
                }
                </g>;
    }

    private _renderWireContextMenu()
    {
        return <FlowWireContextMenu/>;
    }

    private _renderBlockContextMenu()
    {
        return <FlowBlockContextMenu/>;
    }

    render()
    {
        return  <div className={cx('flowWiresHolder')}
                     onContextMenu={this._onPreventBrowserContextMenu}>
                    <svg id={FlowWiresView._FLOW_WIRES_SINGLETON_SVG_ELEMENT}
                         className={cx('flowWiresSvg')}
                         onMouseDown={this._onWiresContainerMouseDown}
                         ref={this._onWiresSvgRef}
                    >
                        {this._renderActiveWire()}
                        {this._renderPermanentWires()}
                    </svg>
                    {this._renderWireContextMenu()}
                    {this._renderBlockContextMenu()}
                </div>;
    }
}
